"use client";

import { Button } from "@/components/ui/button";
import type { AtsNeedsMergeItem } from "../types";

interface Props {
  item: AtsNeedsMergeItem;
  pending: boolean;
  onResolve: (
    itemId: string,
    resolution: "merge" | "keep_separate",
    profileId?: string,
  ) => void;
}

export function NeedsMergeItem({ item, pending, onResolve }: Props) {
  return (
    <div className="flex flex-col gap-3 rounded-lg border border-border p-4">
      <div className="grid grid-cols-2 gap-4">
        <div className="flex flex-col gap-0.5">
          <span className="text-xs text-contrast/50">From ATS</span>
          <span className="text-sm font-medium text-heading">
            {item.ats_candidate.name}
          </span>
          <span className="text-xs text-contrast/60">
            {item.ats_candidate.email ?? "no email"}
          </span>
        </div>
        <div className="flex flex-col gap-2">
          <span className="text-xs text-contrast/50">
            Possible Arbi match{item.candidates.length > 1 ? "es" : ""}
          </span>
          {item.candidates.map((c) => (
            <div
              key={c.profile_id}
              className="flex items-center justify-between gap-2"
            >
              <div className="flex flex-col">
                <span className="text-sm font-medium text-heading">
                  {c.name}
                </span>
                <span className="text-xs text-contrast/60">
                  {c.email ?? "no email"}
                </span>
              </div>
              <Button
                type="button"
                size="sm"
                disabled={pending}
                onClick={() => onResolve(item.id, "merge", c.profile_id)}
              >
                Merge
              </Button>
            </div>
          ))}
        </div>
      </div>
      <div className="flex justify-end">
        <Button
          type="button"
          size="sm"
          variant="outline"
          disabled={pending}
          onClick={() => onResolve(item.id, "keep_separate")}
        >
          Keep separate
        </Button>
      </div>
    </div>
  );
}
